import { z } from 'zod';

/**
 * Schema for customer group form data
 */
export const customerGroupSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('1')
});

export type CustomerGroupFormValues = z.infer<typeof customerGroupSchema>;

/**
 * Initial values for customer group form
 */
export const initialFormValues: CustomerGroupFormValues = {
  ma_nhom: '',
  ten_phan_nhom: '',
  ten2: '',
  trang_thai: '1'
};

/**
 * Schema for customer group detail
 */
export const customerGroupDetailSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên phân nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('1')
});

export type CustomerGroupDetailFormValues = z.infer<typeof customerGroupDetailSchema>;
